import { render, staticRenderFns } from "./DetailLayout.vue?vue&type=template&id=1d879be7&scoped=true"
import script from "./DetailLayout.vue?vue&type=script&lang=js"
export * from "./DetailLayout.vue?vue&type=script&lang=js"
import style0 from "./DetailLayout.vue?vue&type=style&index=0&id=1d879be7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d879be7",
  null
  
)

export default component.exports